var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Loading',{style:({
    color: _vm.color,
    width: _vm.sizeComputed,
    height: _vm.sizeComputed
  })})}
var staticRenderFns = []

export { render, staticRenderFns }